import { useEffect, useState } from 'react';

export const useRefetchFeedback = (loading: boolean) => {
  const [showFeedback, setShowFeedback] = useState(false);
  useEffect(() => {
    if (!loading) {
      setShowFeedback(false);
      return;
    }
    const timeout = globalThis.setTimeout(() => setShowFeedback(true), 150);
    return () => globalThis.clearTimeout(timeout);
  }, [loading]);
  return loading && showFeedback;
};
